import * as React from 'react';
import { Provider } from 'react-redux';
import { Provider as AppStateProvider, AppState } from 'src/AppState/AppState';
import Content from 'src/components/Content/Content';
import { observer } from 'src/utils/mobx-react';
import { Common, ProviderCommon } from 'src/AppState/Common';
import { PopupsStack } from 'src/domains/common/components/PopupsStack';
import { autorun } from 'mobx';
import { setTheme } from 'src/utils/setTheme';
import { useEffect } from 'react';
import { Toaster } from 'src/domains/common/components/toast/toast';
import 'src/tailwind.css';

interface PropsType {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    store: any;
    appState: AppState;
    common: Common;
}

export const App = observer('App', (props: PropsType) => {
    const { store, appState, common } = props;
    const universeTheme = common.appEnvParams.universe_theme;

    useEffect(() => {
        const dispose = autorun(() => {
            setTheme(universeTheme);
        });

        return dispose;
    }, []);

    return (
        <Provider store={store}>
            <AppStateProvider value={appState}>
                <ProviderCommon value={common}>
                    <div id='app'>
                        <PopupsStack />
                        <Toaster />
                        <Content />
                    </div>
                </ProviderCommon>
            </AppStateProvider>
        </Provider>
    );
});
